<template>
<div id="policy_wrapper" v-if="render">
    <div id="policy_wrap">
        <div id="policy_header">
            <span>
                <h1>[{{ menuInfo.title }}] {{ menuInfo.menu_name }}</h1>
            </span>
        </div>
    </div>
    <div id="policy_contents">
        <img :src="menuInfo.image_url" class="center" />

        <div v-if="menuInfo.class === 'using'">
            <span class="policy_title_text">사용하기</span>
            <input type="password" class="input_css" placeholder="관리자 패스워드 입력" v-model="password">
            <input type="button" value="확인" class="button_css" @click="useMenu()">
            <br /><br />
        </div>

        <span class="policy_title_text">메뉴 정보</span>
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                쿠폰 상태 : <span class="label" :class="menuInfo.class">{{ menuInfo.text }}</span>
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                {{ menuInfo.date_text }} : {{ menuInfo.date }}
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                구매자 : {{ menuInfo.user_name }}
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                구매처 : {{ menuInfo.title }}
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                구매 상품: {{ menuInfo.menu_name }}
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                구매 가격: {{ menuInfo.menu_price.toLocaleString() }}잎
            </span>
            <br />
        </span><br />
        <span class="policy_content_text">
            <span class="policy_content_text_bold">
                주문 코드: {{ uuid }}
            </span>
            <br />
        </span><br /><br />

        <span class="policy_title_text">이용 안내</span>
        <span class="policy_content_text">
            <span class="policy_content_text_bold" v-html="menuInfo.detail_text">
            </span>
            <br />
        </span><br /><br />
    </div>
</div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            uuid: this.$route.params.uuid,
            render: false,

            password: "",

            menuInfo: {
                class: "",
                text: "",
                date_text: "",

                service_code: "",
                sub_title: "",
                title: "",
                detail_text: "",
                image_url: null,
                user_name: "",
                menu_name: "",
                menu_price: 0,
                delivery_date: null,
                is_used: 0,
                is_deleted: 0,
                date: null
            }
        }
    },
    async mounted() {
        this.axios.get(`/point/menu_reservation/detail/${this.uuid}`).then(res => {
            if (res.data.length > 0) {
                const data = res.data[0];

                if (data.is_used) {
                    // data.class = "complete";
                    // data.text = "사용 완료";
                    // data.date_text = "사용 일자";
                    // data.date = moment(data.updated).format("YY/MM/DD HH:mm");

                    alert("이미 사용이 완료된 상품입니다.");
                } else if (data.is_deleted) {
                    // data.class = "cancle";
                    // data.text = "구매 취소";
                    // data.date_text = "취소 일자";
                    // data.date = moment(data.updated).format("YY/MM/DD HH:mm");

                    alert("구매 취소된 상품입니다.");
                } else {
                    this.render = true;

                    data.class = "using";
                    data.text = "사용 가능";
                    data.date_text = "구매 일자";
                    data.date = moment(data.created).format("YY/MM/DD HH:mm");

                    this.menuInfo = data;
                }
            } else {
                alert("존재하지 않는 상품입니다.\n관리자에게 문의해주세요.");
            }
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        useMenu() {
            if (this.password === "") {
                alert("관리자 패스워드를 입력해주세요.");
            } else {
                const sendObj = {
                    password: this.password,
                    service_code: this.menuInfo.service_code
                }

                this.axios.put(`/point/menu_reservation/use/${this.uuid}`, sendObj).then(res => {
                    if (res.data.result === "PASSWORD_NOT_MATCHED") {
                        return alert("관리자 패스워드가 일치하지 않습니다.");
                    } else {
                        alert("사용 처리가 완료되었습니다.");

                        this.menuInfo.class = "complete";
                        this.menuInfo.text = "사용 완료";
                        this.menuInfo.date_text = "사용 일자";
                        this.menuInfo.date = moment().format("YY/MM/DD HH:mm");

                        // window.location.reload();
                    }
                }).catch(err => {
                    alert("예상치 못한 에러가 발생하였습니다.\n다시 시도하거나 관리자에게 문의해주세요.");
                    console.log(err);
                });
            }
        }
    }
}
</script>

<style scoped>
.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 70%;
}

#policy_wrapper {
    height: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding-top: 5px;
}

#policy_wrap {
    height: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding-top: 56px;
}

#policy_header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    text-align: center;
    border-bottom: 1px solid #edf0f2;
    max-width: 720px;
}

#policy_header h1 {
    display: inline-block;
    position: relative;
    text-align: center;
    line-height: 3;
    margin: 8px;
    font-weight: bold;
    font-size: 16px;
}

#policy_contents {
    text-align: left;
    font-size: 14px;
    line-height: 2;
    letter-spacing: 0.2px;
    padding: 10px 22px 0px 22px;
    background-color: #fff;
}

.policy_title_text {
    text-align: left;
    display: block;
    font-weight: 700;
    margin: 6px 0px;
}

.policy_content_text {
    text-align: left;
    display: inline-block;
    color: gray;
    font-size: 12px;
}

.policy_content_text_bold {
    font-weight: bold;
    font-size: 13px;
}

.input_css {
    width: 75%;
    height: 32px;
    font-size: 12px;
    border: 0;
    border-radius: 10px;
    outline: none;
    padding-left: 10px;
    background-color: rgb(233, 233, 233);
}

.button_css {
    width: 20%;
    height: 32px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 10px;
    background-color: #206B25;
    border: 1px solid #206B25;
    margin-left: 10px;
    color: #fff !important;
}

.label {
    display: inline;
    padding: 0.5em 0.6em 0.5em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
}

.complete {
    background-color: #666;
}

.cancle {
    background-color: #BB3C3C;
}

.using {
    background-color: #206B25;
}
</style>
